<!-- 输入框  文本、数值-->
<template>
  <div>
    <el-upload
    drag
      class='cashierdiary--upload'
      :action="uploadUrl"
      list-type="picture-card"
      :file-list="getImgList"
      :on-success="handleUploadSuccess"
      :on-error="errorUpload"
      :before-upload="beforeUpload"
      >
      <div class="cashierdiary--upload-tips">
        <i class="el-icon-plus"></i>
        <div class="cashierdiary--upload-tips-title">上传图片</div>
      </div>
      <div slot="file" slot-scope="{file}" class="cashierdiary--upload-items">
        <img
          class="el-upload-list__item-thumbnail"
          @click="handlePictureCardPreview(file)"
          :src="file.url" alt=""
        >
        <img
          src="/static/icon/c_pic_close.png"
          alt="删除当前图片"
          @click.stop="handleClose(file)"
          class="cashierdiary--upload-items-close"
        >
      </div>
    </el-upload>
    <el-dialog :visible.sync="dialogVisible" append-to-body>
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
  </div>
</template>

<script>
  import { uploadUrl,imgShow } from '@/assets/js/apiConfig'
  export default {
    props:{
      imgList:[Array]
    },
    data() {
      return {
        uploadUrl:uploadUrl,
        dialogVisible:false,
        dialogImageUrl:""
      }
    },
    computed:{
      getImgList:{
        get() {
          return this.imgList;
        },
        set(val) {
          this.$emit('getImgList', val);
        }
      }
    },
    methods:{
      // 上传成功
      handleUploadSuccess(res, file, fileList) {
        if(res&&res.code==200) {
        	if(res.data.length) {
        		let obj = {
        			name:file.name,
              uid:file.uid,
        			url:imgShow + res.data[0],
        		};
        		// 给当前操作的图片赋值
            let newArr = this.getImgList.concat([obj]);
        		this.getImgList = newArr;
        	}
        }
      },
      // 上传之前
      beforeUpload() {

      },
      // 移出
      handleClose(file) {
        let nameStr = file.name;
        let copyArr = this.$lodash.cloneDeep(this.getImgList);
        // 给当前操作的图片赋值
        copyArr.forEach((i,index)=>{
        	if(i.name === nameStr) {
        		copyArr.splice(index,1)
        	}
        })
        this.getImgList = copyArr;
      },
      // 错误
      errorUpload() {

      },
      // 点击查看图片
      handlePictureCardPreview(file) {
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
      }
    }
  }
</script>

<style lang="less" scoped>
  @import "../../../../../assets/css/cashierdiary/upload.less";
</style>



// WEBPACK FOOTER //
// src/pages/cashier/components/cashierdiaryTable/attr/c-upload.vue